import React from 'react'
import Client from "../../Client/Client"
const Clientdiv = () => {
  return (
    <div>
      <Client/>
    </div>
  )
}

export default Clientdiv